<template>
  <div class="autocomplete" :class="['is-' + state]">
    <input
      ref="input"
      autocomplete="off"
      type="text"
      class="autocomplete__input form-control"
      :class="['is-' + state]"
      :placeholder="placeholder"
      @input="callOnInput"
      @keyup.down="selectNext()"
      @keyup.up="selectPrevious()"
      @keyup.enter.stop="selectCurrent()"
      @keyup.esc="selectNone()"
      @focus="inputFocus = true"
      @blur="callOnBlur"
    >

    <ul v-if="showList" class="autocomplete__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        @click="callOnSelect(item)"
        class="autocomplete__list__item"
        :class="{ 'autocomplete__list__item--active': (index === selectedIndex) }"
        v-html="showItem(item)"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Autocomplete',

  props: {
    placeholder: {
      type: String,
      default: null,
    },
    parameter: {
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: null,
    },
    itemShow: {
      type: String,
      default: null,
    },
    state: {
      type: String,
      default: null,
    },
    onBlur: {
      type: Function,
      default: () => {},
    },
    onInput: {
      type: Function,
      default: () => {},
    },
    onSelect: {
      type: Function,
      default: () => {},
    },
    onShowText: {
      type: Function,
      default: null,
    },
    completeInput: {
      type: Boolean,
      default: true,
    },
    clearInput: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Boolean,
      default: true,
    },
    onEnter: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      inputFocus: false,
      selectedIndex: -1,
    };
  },

  computed: {
    showList() {
      return this.items.length && this.inputFocus;
    },
  },

  methods: {
    callOnBlur() {
      this.onBlur(this.$refs.input.value, this.parameter);
      setTimeout(() => {
        this.inputFocus = false;
      }, 200);
    },
    /** handle callbacks */
    callOnInput(event) {
      this.onInput(event.target.value);
    },
    callOnSelect(item) {
      // if (this.completeInput) {
      //   this.$refs.input.value = this.showItem(item);
      // }

      this.onSelect(item, this.parameter);
      this.inputFocus = false;
      if (this.clearInput) {
        this.$refs.input.value = '';
      }

      if (this.closeModal) {
        this.close();
      }

      // this.$refs.input.value = this.itemShow ? item[this.itemShow] : item;
    },
    /** methods to be called by other components */
    clear() {
      this.$refs.input.value = '';
      this.close();
    },
    /** utils */
    close() {
      this.items.splice(0, this.items.length);
      this.$set(this, 'selectedIndex', -1);
    },
    /** keys control */
    selectNext() {
      if (this.selectedIndex < this.items.length - 1) {
        this.selectedIndex += 1;
      }
    },
    selectPrevious() {
      if (this.selectedIndex > 0) {
        this.selectedIndex -= 1;
      }
    },
    selectCurrent() {
      if (!this.onEnter) {
        return false;
      }

      if (this.selectedIndex > -1) {
        return this.callOnSelect(this.items[this.selectedIndex]);
      }

      const input = this.$refs.input.value;
      const item = this.itemValue;

      let value = input;
      if (item) {
        value = {};
        value[item] = input;
      }

      return this.callOnSelect(value);
    },
    selectNone() {
      if (this.selectedIndex > -1) {
        this.close();
      }
    },
    /** handle how to display item */
    showItem(item) {
      if (this.onShowText) {
        return this.onShowText(item);
      }
      return this.itemShow ? item[this.itemShow] : item;
    },
  },
};
</script>

<style lang="scss" scoped>
$primary: #201D1D;

.autocomplete {
  position: relative;
  border: 0;
  box-shadow: none;
  padding: 0;
  &__list {
    width: 100%;
    padding: 0;

    position: absolute;
    top: 40px;
    z-index: 30;

    box-shadow: 2px 2px 2px lighten($primary, 25%);
    border: 1px solid $primary;
    border-radius: 5px;
    list-style: none;

    background-color: $primary;
    overflow: auto;
    max-height: 300px;

    &__item {
      padding: 5px 15px;

      cursor: pointer;

      &:hover {
        background-color: #2b2828;
        color: #fff;
      }

      &--active {
        background-color: $primary;
        color: #fff;
      }
    }
  }
  &__input {
    background: transparent;
    width: 100%;
    height: 100%;
    border: 0;
    outline: none;
  }
}
</style>
